import type { Color } from '@mtg-deck-tool/shared';
import { useSymbolMap } from '../../hooks/useSymbolMap.js';

interface ManaSymbolIconsProps {
  colors: Color[];
  size?: number;
  className?: string;
}

/** Maps color letters to the Scryfall symbol key */
const COLOR_TO_SYMBOL: Record<Color | 'C', string> = {
  W: '{W}',
  U: '{U}',
  B: '{B}',
  R: '{R}',
  G: '{G}',
  C: '{C}',
};

export function ManaSymbolIcons({ colors, size = 16, className = '' }: ManaSymbolIconsProps) {
  const symbolMap = useSymbolMap();

  const symbols = colors.length > 0 ? colors : (['C'] as const);

  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {symbols.map((c) => {
        const key = COLOR_TO_SYMBOL[c];
        const svgUri = key ? symbolMap[key] : undefined;
        if (svgUri) {
          return (
            <img
              key={c}
              src={svgUri}
              alt={c}
              title={c}
              width={size}
              height={size}
              className="inline-block"
            />
          );
        }
        // Fallback: text badge
        return (
          <span
            key={c}
            title={c}
            className="inline-flex items-center justify-center rounded-full bg-gray-700 text-gray-300 font-bold border border-gray-600"
            style={{ width: size, height: size, fontSize: size * 0.6 }}
          >
            {c}
          </span>
        );
      })}
    </span>
  );
}
